import React, { useState, useEffect } from "react";
import {
    Box,
    TextField,
    Button,
    Typography,
    Container,
    Paper,
    FormControl,
    InputLabel,
    Select as MuiSelect,
    MenuItem,
    FormHelperText
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import "../assets/css/usuarios.css";
import { getAccounts, updateUser, getCurrentUser, getUserToEdit } from "../services/API";
import Layout from "./Layout";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";
import "alertifyjs/build/css/themes/default.css";
import 'bootstrap/dist/css/bootstrap.min.css';

const FormPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(4),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    [theme.breakpoints.up("md")]: {
        padding: theme.spacing(6),
    },
}));

function ActualizarUsuario() {
    const navigate = useNavigate();

    //accede al id del usuario a editar desde la URL
    const { id } = useParams();
    //console.log("el id del usuario a editar es:",id);

    const ALL_ROLES_OPTIONS = [
        { id: 1, name: "Super User" },
        { id: 2, name: "Administrator" },
        { id: 3, name: "Analyst" },
        { id: 4, name: "Guest" }
    ];

    const ALL_STATES_OPTIONS = [
        { id: 1, name: "Active" },
        { id: 2, name: "Suspended" },
    ];

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        userStatesId: "",
        userRolesId: "",
        profileIds: [],
    });

    const [errors, setErrors] = useState({});
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [accountOptions, setAccountOptions] = useState([]);
    const [loadingAccounts, setLoadingAccounts] = useState(true);
    const [availableStates, setAvailableStates] = useState([]);
    const [availableRoles, setAvailableRoles] = useState([]);
    const [rawProfileIds, setRawProfileIds] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            setLoadingAccounts(true);
            try {
                const currentUser = await getCurrentUser();

                setAvailableStates(ALL_STATES_OPTIONS);

                let filteredRoles = [];
                if (currentUser.userRolesId === 1) {
                    filteredRoles = ALL_ROLES_OPTIONS;
                } else if (currentUser.userRolesId === 2) {
                    filteredRoles = ALL_ROLES_OPTIONS.filter(role => role.id === 2 || role.id === 3 || role.id === 4);
                } else if (currentUser.userRolesId === 3) {
                    filteredRoles = ALL_ROLES_OPTIONS.filter(role => role.id === 3 || role.id === 4);
                }
                setAvailableRoles(filteredRoles);

                const response = await getAccounts();
                const result = response.data.adsAccounts
                    .filter(account => account.countryCodes.includes("US"))
                    .map(account => {
                        const alternateIdUS = account.alternateIds.find(
                            alt => alt.countryCode === "US" && alt.profileId
                        );
                        return {
                            label: account.accountName,
                            value: alternateIdUS ? String(alternateIdUS.profileId) : null
                        };
                    })
                    .filter(item => item.value);

                setAccountOptions(result);
                //copyCurrentUser = currentUser;
            } catch (error) {
                console.error("Error loading data:", error);
            } finally {
                setLoadingAccounts(false);
            }
        };

        fetchData();
    }, []);

    //console.log("id del usuario actual",copyCurrentUser.id);


    useEffect(() => {
        const fetchUser = async () => {
            try {
                const res = await getUserToEdit(id);
                const data = res.data;

                let parsedProfiles = [];
                if (typeof data.profilesId === "string") {
                    try {
                        parsedProfiles = JSON.parse(data.profilesId);
                    } catch (err) {
                        console.warn("Error parsing profileIds:", err);
                        parsedProfiles = [];
                    }
                } else if (Array.isArray(data.profilesId)) {
                    parsedProfiles = data.profilesId;
                }


                // SETEA los profileIds a parte
                setRawProfileIds(parsedProfiles.map(String)); // ← ¡esta linea debe ejecutarse!

                // SETEA formData SIN profileIds aun
                setFormData(prev => ({
                    ...prev,
                    ...data,
                    profileIds: [],
                }));

            } catch (err) {
                alert("User not found");
            }
        };

        fetchUser();
    }, [id]);


    useEffect(() => {
        if (
            !loadingAccounts &&
            accountOptions.length > 0 &&
            rawProfileIds.length > 0
        ) {
            const matchedIds = accountOptions
                .filter(opt => rawProfileIds.includes(String(opt.value)))
                .map(opt => opt.value);

            setFormData(prev => ({
                ...prev,
                profileIds: matchedIds
            }));
        }
    }, [loadingAccounts, accountOptions, rawProfileIds]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        const parsedValue = name === "userRolesId" ? parseInt(value, 10) : value;

        setFormData({
            ...formData,
            [name]: parsedValue,
        });

        if (name === "userRolesId" && (parsedValue !== 2 && parsedValue !== 3 && parsedValue !== 4)) {
            setFormData(prev => ({
                ...prev,
                profileIds: []
            }));
            if (errors.profileIds) {
                setErrors(prev => ({
                    ...prev,
                    profileIds: null
                }));
            }
        }

        if (errors[name]) {
            setErrors({
                ...errors,
                [name]: null,
            });
        }
    };

    const handleMultiSelectChange = (selectedOptions) => {
        const profileIdsValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
        setFormData({
            ...formData,
            profileIds: profileIdsValues,
        });

        if (errors.profileIds) {
            setErrors({
                ...errors,
                profileIds: null,
            });
        }
    };

    const validateForm = () => {
        let tempErrors = {};
        let isValid = true;

        if (!formData.firstName.trim()) {
            tempErrors.firstName = "First name is required.";
            isValid = false;
        }
        if (!formData.lastName.trim()) {
            tempErrors.lastName = "Last name is required.";
            isValid = false;
        }
        if (!formData.email.trim()) {
            tempErrors.email = "Email is required.";
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            tempErrors.email = "Email is not valid.";
            isValid = false;
        }

        if (!formData.userRolesId) {
            tempErrors.userRolesId = "Role is required.";
            isValid = false;
        }

        if (formData.userRolesId && !availableRoles.some(role => role.id === formData.userRolesId)) {
            tempErrors.userRolesId = "You do not have permission to assign this role.";
            isValid = false;
        }

        if ((formData.userRolesId === 2 || formData.userRolesId === 3 || formData.userRolesId === 4) && formData.profileIds.length === 0) {
            tempErrors.profileIds = "At least one Profile ID must be selected for this role.";
            isValid = false;
        }

        setErrors(tempErrors);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitSuccess(false);

        if (validateForm()) {
            try {
                const dataToSend = {
                    firstName: formData.firstName,
                    lastName: formData.lastName,
                    email: formData.email,
                    userStatesId: formData.userStatesId,
                    userRolesId: formData.userRolesId,
                    accountId: localStorage.getItem("selectedAccountValue"),
                    ...((formData.userRolesId === 2 || formData.userRolesId === 3 || formData.userRolesId === 4) && { profileIds: formData.profileIds }),
                };

                console.log("Validated form data ready to send:", dataToSend);

                await updateUser(dataToSend, id);
                setSubmitSuccess(true);
                alertify.success("User updated successfully.");

                setTimeout(() => {
                    navigate("/usuarios");
                }, 2000);
            } catch (error) {
                console.error("Error updating user:", error);
                const errorMessage = error.response.data.message || "Error updating user.";
                setErrors(prev => ({ ...prev, api: errorMessage }));
                alertify.error(errorMessage);
            }
        } else {
            console.log("The form contains validation errors.");
            alertify.error("Please correct the errors in the form.");
        }
    };

    const formatOptionLabel = ({ label, value }) => (
        <div style={{ lineHeight: "1.2" }}>
            <span style={{ display: "block", marginBottom: "2px" }}>{label}</span>
            <span style={{ fontSize: "0.8em", color: "#666", display: "block" }}>
                ID: {value}
            </span>
        </div>
    );

    return (
        <Layout>
            <div className="app-container">
                <Container maxWidth="sm">
                    <FormPaper elevation={3}>
                        <Typography variant="h4" component="h2" align="center" gutterBottom sx={{ mb: 3, color: "primary.dark" }}>
                            Update User
                        </Typography>

                        <form onSubmit={handleSubmit}>
                            <TextField
                                label="First Name"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                                error={!!errors.firstName}
                                helperText={errors.firstName}
                            />
                            <TextField
                                label="Last Name"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                                error={!!errors.lastName}
                                helperText={errors.lastName}
                            />
                            <TextField
                                label="Email"
                                name="email"
                                type="email"
                                value={formData.email}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                                error={!!errors.email}
                                helperText={errors.email}
                            />

                            <FormControl fullWidth margin="normal" error={!!errors.userStatesId}>
                                <InputLabel id="state-select-label">Status</InputLabel>
                                <MuiSelect
                                    labelId="state-select-label"
                                    id="userStatesId"
                                    name="userStatesId"
                                    value={formData.userStatesId}
                                    label="Status"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="">
                                        <em>Select a status</em>
                                    </MenuItem>
                                    {availableStates.map((state) => (
                                        <MenuItem key={state.id} value={state.id}>
                                            {state.name}
                                        </MenuItem>
                                    ))}
                                </MuiSelect>
                                {errors.userStatesId && <FormHelperText>{errors.userStatesId}</FormHelperText>}
                            </FormControl>

                            <FormControl fullWidth margin="normal" error={!!errors.userRolesId}>
                                <InputLabel id="role-select-label">Role</InputLabel>
                                <MuiSelect
                                    labelId="role-select-label"
                                    id="userRolesId"
                                    name="userRolesId"
                                    value={formData.userRolesId}
                                    label="Role"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="">
                                        <em>Select a role</em>
                                    </MenuItem>
                                    {availableRoles.map((role) => (
                                        <MenuItem key={role.id} value={role.id}>
                                            {role.name}
                                        </MenuItem>
                                    ))}
                                </MuiSelect>
                                {errors.userRolesId && <FormHelperText>{errors.userRolesId}</FormHelperText>}
                            </FormControl>

                            {(formData.userRolesId === 2 || formData.userRolesId === 3 || formData.userRolesId === 4) && (
                                <FormControl fullWidth margin="normal" error={!!errors.profileIds}>
                                    <InputLabel shrink htmlFor="profile-ids-select-label">
                                        Profile IDs
                                    </InputLabel>
                                    <Box sx={{ mt: 2 }}>
                                        <Select
                                            id="profile-ids-select-label"
                                            name="profileIds"
                                            isMulti
                                            options={accountOptions}
                                            //value={accountOptions.filter(option => formData.profileIds.includes(option.value))}
                                            value={
                                                Array.isArray(formData.profileIds)
                                                    ? accountOptions.filter(option =>
                                                        formData.profileIds.map(String).includes(String(option.value)) ) : []
                                            }
                                            onChange={handleMultiSelectChange}
                                            isLoading={loadingAccounts}
                                            placeholder={loadingAccounts ? "Loading Profile IDs..." : "Select one or more Profile IDs"}
                                            noOptionsMessage={() => "No Profile IDs available"}
                                            formatOptionLabel={formatOptionLabel}
                                            styles={{
                                                control: (base, state) => ({
                                                    ...base,
                                                    borderColor: errors.profileIds ? "red" : base.borderColor,
                                                    boxShadow: state.isFocused ? (errors.profileIds ? "0 0 0 2px red" : "0 0 0 2px rgba(25, 118, 210, 0.5)") : "none",
                                                    "&:hover": {
                                                        borderColor: errors.profileIds ? "red" : "rgba(0, 0, 0, 0.87)",
                                                    },
                                                }),
                                                multiValue: (base) => ({
                                                    ...base,
                                                    backgroundColor: "#e0e0e0",
                                                }),
                                                multiValueLabel: (base) => ({
                                                    ...base,
                                                    color: "#333",
                                                }),
                                                multiValueRemove: (base) => ({
                                                    ...base,
                                                    color: "#777",
                                                    "&:hover": {
                                                        backgroundColor: "#d0d0d0",
                                                        color: "#333",
                                                    },
                                                }),
                                            }}
                                        />
                                    </Box>
                                    {errors.profileIds && <FormHelperText error>{errors.profileIds}</FormHelperText>}
                                </FormControl>
                            )}

                            {submitSuccess && (
                                <Typography variant="body1" color="success.main" align="center" sx={{ mt: 2 }}>
                                    User updated successfully. Redirecting...
                                </Typography>
                            )}

                            {errors.api && (
                                <Typography variant="body2" color="error" align="center" sx={{ mt: 2 }}>
                                    {errors.api}
                                </Typography>
                            )}

                            <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between", gap: 2 }}>
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    component={Link}
                                    to="/usuarios"
                                    fullWidth
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                >
                                    Update
                                </Button>
                            </Box>
                        </form>
                    </FormPaper>
                </Container>
            </div>
        </Layout>
    );
}

export default ActualizarUsuario;